import React, { useCallback, useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { colors, IconButton } from '@sweep-io/sweep-design';
import { MoreActionsHorizontal } from '@sweep-io/sweep-design/dist/icons';
import { useReactFlow } from '@xyflow/react';
import { SweepCanvasRfNode } from '../../canvas-types/nodeTypesData';

interface NodeActionsMenuProps {
  nodeId: string;
}

export const NodeActionsMenu = ({ nodeId }: NodeActionsMenuProps) => {
  const { setNodes } = useReactFlow<SweepCanvasRfNode>();
  const [menuAnchor, setMenuAnchor] = useState<(EventTarget & Element) | null>(null);

  const handleMenuClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuAnchor(null);
  }, []);

  const handleDeleteNode = useCallback(() => {
    setNodes((nodes) => nodes.filter((node) => node.id !== nodeId));
    handleCloseMenu();
  }, [nodeId, setNodes, handleCloseMenu]);

  return (
    <>
      <IconButton
        variant="squared"
        size="small"
        onClick={handleMenuClick}
        pressed={Boolean(menuAnchor)}
      >
        <MoreActionsHorizontal />
      </IconButton>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            minWidth: '172px',
          },
        }}
        MenuListProps={{
          className: 'rich-text-editor-toolbar-item',
        }}
      >
        <MenuItem onClick={handleDeleteNode} sx={{ color: colors.feedback.destructive }}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};
